import React from 'react';
import styles from './styles.css.js';

var FullBlockLoader = function FullBlockLoader(_a) {
  var className = _a.className,
      Loader = _a.loader;
  return React.createElement("div", {
    className: styles.wrapper
  }, React.createElement("div", {
    className: styles.loader
  }, React.createElement(Loader, {
    className: className
  })));
};

export default FullBlockLoader;
//# sourceMappingURL=index.js.map
